import Vuex from 'vuex';

function createStore() {
  return new Vuex.Store({
    state: {
      user: null,
      isPaid: null,
    },
    mutations: {
      updateUser(state, user) {
        state.user = user;
        if(user['is_paid']) {
          state.isPaid = true;
        }
      },
      logout(state, validation) {
        if(validation === 'clear'){
          state.isPaid = null;
          state.user = null;
        }
      },
      updateIsPaid(state, status) {
        state.isPaid = status;
      }
    },
    getters: {
      getUser: (state) => state.user,
      getIsPaid: (state) => state.isPaid,
    }
  });
}

export default createStore;



// WEBPACK FOOTER //
// ./src/store.js